var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { E_CASE_UPDATE_TRANSLATED_FIELDS } from 'src/redux/cases/types/casesTypes';
import { ComparisonItem, } from 'src/ui/views/dynamics/CaseGlobalViewPage/sections/History/HistoryList/HistoryItems/ComparisonItem/ComparisonItem';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var CaseUpdateItem = function (props) {
    var i18n = props.i18n, caseUpdate = props.caseUpdate;
    var caseFields = caseUpdate.caseFields, update = caseUpdate.update;
    var patch = update.patch, previous = update.previous;
    //inside patch path remove first / and replace others with .
    var reformatPathToKeyPath = patch.map(function (item) {
        return __assign(__assign({}, item), { path: item.path.slice(1).replace(/\//g, '.') });
    });
    // [{key: 'caseClientId', label: 'caseClientId'}]
    //let fields = [{ key: 'caseClientId', label: 'caseClientId' }]
    var fields = reformatPathToKeyPath.map(function (item) {
        var variableName = item.path.split('.').pop();
        if (variableName === E_CASE_UPDATE_TRANSLATED_FIELDS.CASE_CLIENT_ID) {
            return {
                key: variableName,
                label: getPropsByKeyPath(i18n.keyValueMap, "history.comparison.labels.".concat(variableName)),
            };
        }
        return {
            key: variableName,
            label: variableName,
        };
    });
    var _a = reformatPathToKeyPath.reduce(function (acc, curr) {
        var _a, _b, _c;
        var nextValue = acc.nextValue, previousValue = acc.previousValue;
        var op = curr.op, path = curr.path;
        var valueName = path.split('.').pop();
        if (op === 'add') {
            return __assign(__assign({}, acc), { nextValue: __assign(__assign({}, nextValue), (_a = {}, _a[valueName] = getPropsByKeyPath(caseFields, curr.path), _a)) });
        }
        else if (op === 'replace') {
            return __assign(__assign({}, acc), { nextValue: __assign(__assign({}, nextValue), (_b = {}, _b[valueName] = getPropsByKeyPath(caseFields, curr.path), _b)), previousValue: __assign(__assign({}, previousValue), (_c = {}, _c[valueName] = getPropsByKeyPath(previous, curr.path), _c)) });
        }
        return acc;
    }, { nextValue: {}, previousValue: {} }), previousValue = _a.previousValue, nextValue = _a.nextValue;
    var description = getPropsByKeyPath(i18n.modules, 'timeline.caseUpdate.message');
    var content = _jsx("p", { children: description });
    return (_jsx(ComparisonItem, { i18n: i18n, fields: fields, previousIdentity: previousValue, nextIdentity: nextValue, description: content }));
};
